import axios from 'axios';

const csrfMeta = document.querySelector('meta[name="csrf-token"]');
axios.defaults.headers.common['X-CSRF-Token'] = csrfMeta ? csrfMeta.getAttribute('content') : '';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default axios;
